module.exports = __webpack_public_path__ + "media/6.c9d47f15.mp3";